import { render, staticRenderFns } from "./GiftFloat.vue?vue&type=template&id=ac8a5050&scoped=true"
import script from "./GiftFloat.vue?vue&type=script&lang=js"
export * from "./GiftFloat.vue?vue&type=script&lang=js"
import style0 from "./GiftFloat.vue?vue&type=style&index=0&id=ac8a5050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8a5050",
  null
  
)

export default component.exports